import React, { useState, useEffect } from 'react';
import { Box, Paper, Typography, Button, LinearProgress } from '@mui/material';

const LoggedOutPage = () => {
    const [countdown, setCountdown] = useState(5);

    const handleLogin = () => {
        window.location.href = '/login';
    };

    // This effect handles the timer and auto-redirect.
    useEffect(() => {
        if (countdown === 0) {
            handleLogin();
            return;
        }

        const timerId = setInterval(() => {
            setCountdown(prev => prev - 1);
        }, 1000);

        return () => clearInterval(timerId);
    }, [countdown]);

    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: '100vh',
                backgroundColor: '#f4f6f8'
            }}
        >
            <Paper sx={{ p: 4, textAlign: 'center', maxWidth: '550px', width: '100%' }}>
                <Typography variant="h4" gutterBottom>
                    You have been successfully logged out.
                </Typography>

                <Typography variant="body2" color="text.secondary" sx={{ mt: 2, mb: 1 }}>
                    Redirecting to login page in {countdown} seconds...
                </Typography>

                <LinearProgress
                    variant="determinate"
                    value={(countdown / 5) * 100}
                    sx={{ mb: 3 }}
                />

                <Button variant="contained" color="primary" onClick={handleLogin}>
                    Log In Again
                </Button>
            </Paper>
        </Box>
    );
};

export default LoggedOutPage;